module.exports = __webpack_public_path__ + "static/media/group-photo-settings.78c56cf2.png";